import { statementGroup } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const fetchAccountStatements = gql`
  query FetchAccountStatements {
    myAccounts {
      id
      __typename
      forStatements {
        id
        name
        accountNumber
        status
        __typename
        ... on InternalSavingsAccount {
          monthlyStatements {
            ...statementGroup
          }
        }
        ... on InternalAdvanceAccount {
          monthlyStatements {
            ...statementGroup
          }
        }
        ... on InternalChargeCardAccount {
          monthlyStatements {
            ...statementGroup
          }
        }
        ... on InternalCheckingAccount {
          monthlyStatements {
            ...statementGroup
          }
        }
        ... on InternalPersonalLoanAccount {
          monthlyStatements {
            ...statementGroup
          }
        }
        ... on VaroMoneyAccount {
          monthlyStatements {
            ...statementGroup
          }
        }
        ... on InternalLineOfCreditAccount {
          monthlyStatements {
            ...statementGroup
          }
        }
      }
    }
  }
  ${statementGroup}
`;

export default fetchAccountStatements;
